import {
    NotificationCondition,
    NotificationDispatchStatus,
    NotificationPeriodicity,
    NotificationSendMode,
    NotificationType,
    UserRoleEnum,
} from 'core/enums';
import { AbstractModel } from './abstract.model';

export interface NotificationUserModel {
    id: number;
    fullName: string;
}

export interface NotificationListItemModel extends AbstractModel {
    id: number;
    title: string;
    notificationType: NotificationType;
    roles: UserRoleEnum[];
    sendMode: NotificationSendMode;
    periodicity: NotificationPeriodicity;
    scheduledAt: string | null;
    lastSentAt: string | null;
    nextSendAt: string | null;
    isEnabled: boolean;
}

export interface NotificationModel extends NotificationListItemModel {
    messageText: string;
    condition: NotificationCondition | null;
    createDate: string;
    modifyDate: string | null;
    createUser: NotificationUserModel | null;
    modifyUser: NotificationUserModel | null;
}

export interface NotificationSaveModel {
    title: string;
    notificationType: NotificationType;
    messageText: string;
    roles: UserRoleEnum[];
    sendMode: NotificationSendMode;
    periodicity: NotificationPeriodicity;
    scheduledAt?: string | null;
    condition: NotificationCondition | null;
    isEnabled: boolean;
}

export interface NotificationListRequestModel {
    title?: string;
    notificationType?: NotificationType;
    roles?: UserRoleEnum[];
    sendMode?: NotificationSendMode;
    periodicity?: NotificationPeriodicity;
    isEnabled?: boolean;
    page: number;
    pageSize: number;
    orderBy?: string;
    reverse?: boolean;
}

export interface NotificationDispatchesRequestModel {
    page: number;
    pageSize: number;
    orderBy: string;
    reverse: boolean;
}

export interface NotificationDispatchModel {
    id: number;
    eventAt: string | null;
    plannedAt: string | null;
    startedAt: string | null;
    sentAt: string | null;
    completedAt: string | null;
    status: NotificationDispatchStatus;
    statusName: string;
    recipientCount: number;
    attemptCount: number;
    nextAttemptAt: string | null;
    errorMessage: string | null;
}
